<template>
  <div class="c2-task-main" v-if="bodyShow">
    <h2 class="title">{{title}}</h2>
    <public-dialogue
      v-if="data.testid&&data.testid != 0"
      :testid="data.testid"
      :cid="$route.query.cid"
      :taskid="$route.query.id"
    ></public-dialogue>
    <!--  -->
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="['self-discovery-group',index==0?'on':'']"
    >
      <div class="text left-discovery">{{item.config.text[0].label}}</div>
      <div class="input-group">
        <input
          v-if="item.config.variable.name.type=='text'"
          type="text"
          @input="textareaChange(index,item.content,item.id,item.config.variable.name.word)"
          v-model="item.content"
          :placeholder="item.config.variable.name.placeholder"
        />
        <textarea
          v-if="item.config.variable.name.type=='textarea'"
          @input="textareaChange(index,item.content,item.id,item.config.variable.name.word)"
          v-model="item.content"
          :placeholder="item.config.variable.name.placeholder"
        ></textarea>
        <span
          class="c2-word-limit"
        >{{item.content?item.content.length:0}}/{{item.config.variable.name.word}}</span>
      </div>
      <div class="text right-discovery">{{item.config.text[1].label}}</div>
    </div>
    <!-- 引入项目攻略入口 -->
    <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
    <!-- submit -->
    <button :class="['c-submit',bool?'on':'']" @click="submithandle">提交</button>
  </div>
</template>

<script>
import { index, subtable } from "@/api/course";
import { getStorage, setStorage } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
import TaskStrategy from "@c/course/task-strategy"
export default {
  data() {
    return {
      bodyShow: false,
      title: "",
      list: [],
      userfield: [],
      bool: true,
      word_num: 0,
      data: {}
    };
  },
  components:{
    TaskStrategy
  },
  methods: {
    //改变输入框时触发------- 下标、内容、id、字数长度
    textareaChange(index, content, id, word) {
      this.$forceUpdate();
      if (content && content.length > word) {
        this.$set(this.list[index], "content", content.slice(0, word));
        this.$toast(`最多只能输入${word}个字。/(ㄒoㄒ)/~~`);
      } else {
        setStorage(this.$route.path, "id" + id, content);
      }
      this.validationHandle();
    },
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      // 获取页面初始化数据
      index({
        cid: this.$route.query.cid,
        cpid: this.$route.query.pid,
        cptid: this.$route.query.id
      }).then(data => {
        this.$toast.clear();
        if (data.code === 10002) {
          this.$toast(data.data.msg);
          return;
        }
        this.list = data.field;
        this.userfield = data.userfield;
        document.title = this.$route.query.name;
        this.title = data.title;
        this.data = data;
        this.validationHandle(true);
        this.loadinShow = false;
        this.bodyShow = true;
      });
    },
    validationHandle(bl) {
      let b = true;
      if (this.list && this.list.length == 0) {
        this.bool = false;
        return;
      }
      this.list.forEach((item, index) => {
        // 判断是否是初始化
        if (bl) {
          // 判断是否已提交过数据
          if (this.userfield && this.userfield.length > 0) {
            this.userfield.forEach((item2, key) => {
              if (item2.content && item2.field_id == item.id) {
                this.list[index].content = item2.content ? item2.content : "";
              }
            });
          } else {
            let storage = getStorage(this.$route.path, "id" + item.id);
            this.list[index].content = this.list[index].content
              ? this.list[index].content
              : storage || "";
          }

          if(!this.list[index].content) {
            this.list[index].content = '';
          }
        }
        // 判读是否有空
        if (
          this.list[index].type == "fill" &&
          (!this.list[index].content || this.list[index].content == "")
        ) {
          b = false;
        }
      });
      this.bool = b;
    },
    submithandle() {
      if (this.bool) {
        let arr = [];
        this.list.forEach((item, index) => {
          if (item.content) {
            arr.push({
              field_id: item.id,
              content: item.content
            });
          }
        });
        subtable({
          cid: this.$route.query.cid,
          form_id: this.list[0].form_id, //引入form_id都是一样的，所以取一个就可以
          field: JSON.stringify(arr)
        }).then(data => {
          this.$toast({
            duration: 1000,
            message: "提交成功！",
            onClose: () => {
              this.$router.push({
                path: "/project_report",
                query: {
                  cid: this.$route.query.cid,
                  cpid: this.$route.query.pid,
                  taskid: this.$route.query.id
                }
              });
            }
          });
        });
      }
    }
  },
  created() {
    this.pullData();
    shareCon("course2", this);
  }
};
</script>

<style lang="scss" scoped>
.c2-task-main {
  padding: 40px 30px 80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #f0f0f0;
  h2.title {
    font-weight: bold;
    font-size: 36px;
    color: #333333;
    text-align: center;
  }
  .c-submit {
    width: 174px;
    height: 66px;
    background: #cccccc;
    border-radius: 33px;
    font-size: 34px;
    color: #ffffff;
    border: 0;
    margin: 140px auto auto;
  }
  .c-submit.on {
    background-color: #ea345c;
  }
  .self-discovery-group {
    margin-bottom: 14px;
    display: flex;
    line-height: 70px;
    font-size: 26px;
    color: #333333;
    box-sizing: border-box;
    .text {
      font-size: 32px;
    }
    .left-discovery {
      width: 128px;
      text-align: right;
      margin-right: 16px;
    }
    .right-discovery {
      width: 88px;
      line-height: 42px;
      text-align: left;
      margin-left: 16px;
    }
    .input-group {
      position: relative;
      width: 428px;
      line-height: 1;
      input {
        border: none;
        height: 70px;
        line-height: 70px;
        background: #ffffff;
        border-radius: 8px;
        padding: 0 20px;
        box-sizing: border-box;
        width: 100%;
      }
      textarea {
        border: none;
        height: 144px;
        line-height: 40px;
        background: #ffffff;
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        resize: none;
      }
      .c2-word-limit {
        position: absolute;
        font-size: 18px;
        color: #999;
        bottom: 8px;
        right: 8px;
        line-height: 1;
      }
    }
  }
  .self-discovery-group.on {
    margin-top: 40px;
    .input-group {
      width: 254px;
    }
  }
}
</style>